export default "__VITE_ASSET__Bm7Qc$p0__"